import React from 'react';
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import Carousel from 'react-bootstrap/Carousel';
// https://react-bootstrap.github.io/components/carousel/

// import {SectionTitle} from 'component/reuse/title';


export default class Quotes extends React.Component {

  render (){
    const quotes = [
      {author: "Albert Allen Bartlett", text: "The greatest shortcoming of the human race is our inability to understand the exponential function.",},

      // {author: "", text: "",},
    ];

    const quote = quotes[0];
    return (
      
      <section id="quotes" className="content-section flex-center py-5 bg-light box-shadow">
        <div className=" ">
          {/* <Carousel controls={false} indicators={false} interval={10000}> */}

            {/* {quotes.map(function(quote, idx){
              return (
                <Carousel.Item key={"_"+idx}> */}
                  <div className="container">
                    <p className="text-center text-black-6">{quote.text}</p>
                    {(quote.author)? (<p className="text-right text-black-3">- {quote.author}</p>):''}
                  </div>
                {/* </Carousel.Item>
  
              )
            })} */}
          {/* </Carousel> */}
        </div>
      </section>
    )
  }
}